// import PropTypes from 'prop-types';
import React, {createContext, useCallback, useContext, useState} from 'react';

import {useFilter} from '@/contexts/FilterContext';
import {useTableGrid} from '@/contexts/tableGridContact';

export const createContextList = (usePagination, name, pageConfig) => {
  const Context = createContext();

  function Provider (props) {
    const { search, filter } = useFilter();
    const { currentPage, currentPageSize: currentTotalPages } = useTableGrid();
    const [openModal, setOpen] = useState({ open: false });

    const onOpenModal = useCallback((payload) => {
      setOpen({ open: true, payload });
    }, []);

    const onCancelModal = useCallback(() => {
      setOpen({ open: false });
    }, []);

    const {
      page, data, totalPages, setPage, isFetching, activeKey, setSize, size, setSort
    } = usePagination(search, filter, { ...pageConfig, page: currentPage, size: currentTotalPages || 10 });

    return (
      <Context.Provider value={{
        page: currentPage || page,
        data,
        totalPages,
        setPage,
        isFetching,
        activeKey,
        openModal,
        onOpenModal,
        onCancelModal,
        setSize,
        size,
        setSort
      }} {...props} />
    );
  }

  function useList () {
    const context = useContext(Context);
    if (context === undefined) {
      throw new Error(`use${name} must be used within a ${name}Provider`);
    }
    const {
      page,
      data,
      totalPages,
      setPage,
      isFetching,
      activeKey,
      openModal,
      onOpenModal,
      onCancelModal,
      setSize,
      size,
      setSort
    } = context;

    return {
      page,
      data,
      totalPages,
      setPage,
      isFetching,
      activeKey,
      openModal,
      onOpenModal,
      onCancelModal,
      setSize,
      size,
      setSort
    };
  }

  Provider.propTypes = {};

  return { Provider, useList };
};
